<script>
// @ts-check

export default {
  data: function() {
    return {
      tableinfos: [
        ['Subject', 'TSIA', '', 'SAT*', '', 'ACT'],
        [
          'ELA',
          'at leat 351 on Reading',
          'OR',
          'at least 500 on Critical Reading AND at least 1070 Total',
          'OR',
          'at least 19 on English AND at least 23 Composite',
        ],
        [
          'Mathematics',
          'at least 350 on Mathematics',
          'OR',
          'at least 500 on Mathematics  AND at least 1070 Total',
          'OR',
          'at least 19 on Mathematics AND at least 23 Composite',
        ],
      ],
    }
  },
}
</script>

<template>
  <v-card style="min-width:320px">
    <v-card-text>
    <b>College Readiness</b> is determined by a student’s score on the Texas Success Initiative Assessment (TSIA), the SAT, or the ACT. For English language arts, the college-ready TSIA score is at least 351 on Reading; on the SAT, at least 500 on Critical Reading plus at least 1070 total; on the ACT, at least 19 on English plus at least 23 Composite. For mathematics, the college-ready TSIA score is at least 350; on the SAT, at least 500 on Mathematics plus at least 1070 total; on the ACT, at least 19 on Mathematics plus at least 23 Composite.
    <br>
    </v-card-text>
    <v-card-text>For the small percentage of students who took the redesigned SAT examination, scores were converted to the equivalent scores on the previous SAT using College Board concordance tables.</v-card-text>
  </v-card>
</template>
